<template>
  <div class="order-new">
    <!-- 客户信息 -->
    <div class="subtitle">购买人信息<span>（*项为必填项）</span></div>
    <ul class="ca-info">
      <li>
        姓名<span class="red">*</span>
        <span class="inter">
          <input
            ref="customerName"
            type="text"
            value=""
            v-model.trim="name"
            placeholder="请填写"
          />
        </span>
      </li>
      <li>
        手机号码<span class="red">*</span>
        <span class="inter">
          <input
            type="tel"
            placeholder="请填写"
            maxlength="11"
            value=""
            style="ime-mode: disabled"
            v-model.trim="mobile"
          />
        </span>
      </li>
      <li>
        回执编号<span class="red"></span>
        <span class="inter">
          <input
            type="text"
            placeholder="请填写风险评估问卷的回执编号"
            maxlength="15"
            value=""
            v-model.trim="survey_code"
          />
        </span>
      </li>
    </ul>
    <div class="actions mt-50">
      <mt-button type="primary" @click="nextStage">下一步</mt-button>
      <p class="mt-50" style="font-size: 13px; padding: 5px 20px">
        温馨提示：订单创建过程中遇到问题，可在企业号【我的客户】栏目中直接发送问题消息到后台，值班技术支持会尽快给您回复。
      </p>
      <p style="margin-top: 100px; font-size: 13px; padding: 5px 20px">
        有疑问？<a href="javascript:void(0);" @click="toFaq">点这里</a>
      </p>
    </div>
    <mt-popup
      v-model="selectPhoneVisible"
      position="bottom" style="width:100%">
      <mt-picker style="width:100%" :showToolbar=true :slots="selectCustomerList" @change="onSelectCustomerChange">
        <mt-button style="width:100%;height:41px;letter-spacing:2px;" type="primary" size="large" @click="onSubmitClick">点击选择套餐</mt-button>
      </mt-picker>
    </mt-popup>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { Button, Popup, Picker } from "mint-ui";

export default {
  name: "OrderNew",
  components: {
    "mt-button": Button,
    "mt-popup": Popup,
    "mt-picker": Picker
  },
  data: () => ({
    selectPhoneVisible: false,
    selectCustomerList: [{
          flex: 1,
          values: []
        }],
    name: "",
    mobile: "",
    survey_code: ""
  }),
  computed: {
    ...mapGetters({
      qyh: "getQyh",
      order: "getNewOrder"
    })
  },
  created: function () {},
  mounted: function () {
    this.setPageTitle("新建订单");
  },
  watch: {
    mobile (item1, item2) {
      if (this.selectCustomerList[0].values.indexOf(item1) !== -1) {
        return
      }
      var reg = /^0?1[3|4|5|6|7|8][0-9]\d{8}$/;
      if (reg.test(item1)) {
        this.getPhone()
      } else {
        this.selectCustomerList[0].values = [];
      }
    }
  },
  methods: {
    getPhone: function () {
    },

    nextStage() {
      if (this.name === "") {
        this.toast("请填写完整信息");
        return
      }

      if (this.selectCustomerList[0].values.length < 1) {
        this.selectCustomerList[0].values = [this.mobile];
      }

      this.onSubmitClick()
    },

    onSelectCustomerChange: function(picker, values) {
      this.mobile = values[0]
    },

    toFaq() {
      window.location.href =
        "http://qy.zhongyingtougu.com/qyapp.php?s=/faq/index/questions_list&faq_category_id=1&code=zXZkPLmXXgQ6NTHfsJYdqLVVTPSHKBH2pGdCU32P94c&state=364b674e77e9d800db45dc4970cbd9eb";
    },
    onSubmitClick(event) {
      this.onCheckCustomerInfo(event);
    },
    onCheckCustomerInfo(event) {
      if (!this.onValidCustomerForm()) {
        return;
      }

      let order = {name: this.name, mobile: this.mobile, survey_code: this.survey_code}
      this.$store.dispatch("setNewOrder", {order: order});
      this.loading("正在校验信息...");
      this.$http.post("/api/customers", order).then(
        (response) => {
          this.loadingHide();
          var rs = response.body;
          console.log("response:", rs);
          if (rs.code === 0) {
            let cust = rs.data;
            console.log("customer:", cust);

            if (typeof cust[0] !== "undefined") {
              if (typeof cust[0][0] !== "undefined") {
                this.$store.dispatch("setNewCustomer", { customer: cust[0][0] });
              } else {
                this.$store.dispatch("setNewCustomer", { customer: cust[0] });
              }
            } else {
              this.$store.dispatch("setNewCustomer", { customer: cust });
            }

            this.$router.push({ name: "OrderNewPkg" });
          } else {
            // 显示文字
            this.toast(rs.message);
          }
        },
        (response) => {
          // error callback
          console.log(response);
          this.handleHttpError(response);
        }
      );
    },
    onValidCustomerForm() {
      console.log(this.order)
      if (!this.name) {
        this.toast("请输入姓名");
        return false;
      }
      if (!this.mobile) {
        this.toast("请输入手机号");
        return false;
      }
      if (!/^1\d{10}$/.test(this.mobile)) {
        this.toast("手机号格式不正确，请输入11位数字");
        return false;
      }
      if (
        this.survey_code &&
        !/^FX\d{4,13}$/.test(this.order.survey_code)
      ) {
        this.toast("问卷回执编号格式不正确，请输入FX开头的15位编号");
        return false;
      }
      return true;
    }
  }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// OrderNew.vue?372a7524